import { useEffect } from 'react';
import { CustomContact } from './CustomContact';
import { PersonSearch } from './PersonSearch';
import { useManagePersonListContext } from './PersonSelectorContext';
import { PatientSelectorScreenEnum } from './types';

export const PersonListContainer = () => {
  const { personSelectorScreen, setPersonSelectorScreen } = useManagePersonListContext();

  useEffect(() => {
    return () => {
      setPersonSelectorScreen(PatientSelectorScreenEnum.PERSON_SEARCH);
    };
  }, []);

  return (
    <>
      {personSelectorScreen === PatientSelectorScreenEnum.PERSON_SEARCH && <PersonSearch />}
      {personSelectorScreen === PatientSelectorScreenEnum.CUSTOM_CONTACT && <CustomContact />}
    </>
  );
};
